import styled from 'styled-components';
import { Form } from 'antd';

export const ConstructorForm = ({ children }) => {
  return (
    <StyledForm
      layout='vertical'
      styles={{
        content: {
          marginBottom: '0px'
        }
      }}
    >
      {children}
    </StyledForm>
  );
};

const StyledForm = styled(Form)`
  .ant-form-item {
    margin-bottom: 8px;
  }
  .ant-form-item-label {
    padding-bottom: 2px;
  }
  .ant-form-item-label > label {
    font-size: 12px;
  }
  .ant-input,
  .ant-select-selector,
  .ant-checkbox-label,
  .ant-radio-label,
  .ant-btn {
    font-size: 14px;
  }
`;
